// extracted by mini-css-extract-plugin
export default {"indtroduction":"CardIntroduction_indtroduction__H2N5t"};